class ScriptsProvider {
    /**
     * @param {String} url
     * @param {CallableFunction} callback
     * @return {HTMLScriptElement}
     */
    static create(url, callback) {
        let script = document.createElement('script');
        script.src = url;
        script.type = 'text/javascript';
        script.defer = false;
        script.async = true;

        if (callback) {
            script.onreadystatechange = () => {
                if (script.readyState === 'complete' || script.readyState === 'loaded') {
                    script.onreadystatechange = script.onload = null;
                    callback();
                }
            };

            script.onload = () => {
                this.onreadystatechange = this.onload = null;
                callback();
            };
        }

        return script;
    }

    /**
     * @param {HTMLScriptElement} script
     * @private
     */
    static _attachToHead(script) {
        let head = document.getElementsByTagName('head').item(0);
        head.appendChild(script);
    }

    /**
     * @param {String} url
     * @return {Boolean}
     */
    static has(url) {
        return document.querySelector(`script[src="${url}"]`) !== null;
    }

    /**
     * @param {String} url
     * @param {CallableFunction} callback
     */
    static add(url, callback = null) {
        this._attachToHead(this.create(url, callback));
    }

    /**
     * @param {String} url
     * @param {Object} attributes
     * @param {CallableFunction} callback
     */
    static addWithAttributes(url, attributes, callback = null) {
        let script = this.create(url, callback);

        Object.entries(attributes).forEach(([name, value]) => {
            script.setAttribute(name, String(value));
        });

        this._attachToHead(script);
    }
}

export {ScriptsProvider};
